import React from "react";
import { Link } from "react-router-dom";

const variants = {
  primary:
    "bg-orange-500 text-white shadow-orange-500/25 hover:bg-orange-600 hover:shadow-orange-500/35",
  secondary:
    "border border-white/20 bg-white/10 text-white backdrop-blur hover:bg-white/20",
};

const HeroActionButton = ({
  to,
  href,
  children,
  icon: Icon,
  variant = "primary",
  onClick,
}) => {
  const className = `
    inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl px-5 py-3
    text-sm font-bold shadow-lg transition
    hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2
    focus-visible:ring-orange-300 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950
    ${variants[variant] || variants.primary}
  `;

  const content = (
    <>
      {Icon && <Icon className="h-4 w-4" />}
      <span>{children}</span>
    </>
  );

  if (href) {
    return (
      <a href={href} className={className} onClick={onClick}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to || "/"} className={className} onClick={onClick}>
      {content}
    </Link>
  );
};

export default HeroActionButton;